/**
 * Scripts for the edit page
 *
 * Only for edit page, not used "inline", or in any popups etc
 */
$(document).ready(function () {
    $('.js-edit-submit-button').click(function (ev) {
        ev.preventDefault();
        mark_unedited();

        $('#edit-post-type').val($(this).data('post-type'));
        $('#edit-form').submit();
    });

  $('.js-check-submit-button').click(function (ev) {
    ev.preventDefault();

    $.ajax({
      type: 'POST',
      url: "/email/validate",
      data: {
        "_token": $('#token').val(),
        'blade' : ($('textarea[name="data[content]"]')).val()
      },
      dataType: "json",
      success: function(resultData) {
        document.getElementById("helpBlock-Content").innerHTML
            = '<div class="alert alert-' + resultData.color + ' col-sm-12"><ul id="alert-list"></ul></div>';

        (resultData.messages).forEach(function (message) {
          var ul = document.getElementById("alert-list");
          var li = document.createElement("li");
          li.appendChild(document.createTextNode(message));
          ul.appendChild(li);
        });
      }
    });
  });

    var url = document.location.toString();
    if (url.match('#')) {
        var scrollHeight = $(document).scrollTop();
        $('#visible-tab').val("#" + url.split('#')[1]);
        $('.nav-tabs a[data-target="#' + url.split('#')[1] + '"]').tab('show');
        $('.chosen-container').css("width", "100%");
        setTimeout(function() {
            $(window).scrollTop(scrollHeight );
        }, 1);
    }

    $('.tabs-container .nav-tabs').on('click', 'a', function (e) {
        e.preventDefault();
        window.location.hash = $(this).data('target');
        $('#visible-tab').val($(this).data('target'));

        $(this).tab('show');
        $('.chosen-container').css("width", "100%");
    });

    $('.js-tagsinput').tagsinput({
        tagClass: 'label label-primary'
    });

    $('div.edit input, div.edit textarea, div.edit select').change(function ()
    {
        mark_edited();
    });
});

/**
 * Deal with "changed" leave warning
 * @type {boolean}
 */
var edited = false;
function mark_edited() {
    edited = true;
}

function mark_unedited() {
    edited = false;
}

window.onbeforeunload = function() {
    if (edited)
    {
        var message = "Are you sure you want to navigate away from this page?\n\nAny changes made will be lost.";
        if (confirm(message)) return true;
        else return false;
    }
}